import { RefObject, useEffect } from "react";

interface Props {
    tableWrapperRef: RefObject<HTMLDivElement | null>;
    setScrollLeft: (value: number) => void;
}

export default function useTableHorizontalScroll({ tableWrapperRef, setScrollLeft, }: Props) {
    
    /* Track horizontal scrolling of the table.  */
    useEffect(() => {
        const tableWrapper = tableWrapperRef.current;

        if (!tableWrapper) return;

        const handleHorizontalScroll = () => {
            setScrollLeft(tableWrapper.scrollLeft);
        };

        tableWrapper.addEventListener("scroll", handleHorizontalScroll, {
            passive: true,
        });

        handleHorizontalScroll();

        return () => {
            tableWrapper.removeEventListener(
                "scroll",
                handleHorizontalScroll
            );
        };
    }, [tableWrapperRef, setScrollLeft]);
}